import { render, staticRenderFns } from "./AccountControls.vue?vue&type=template&id=c2422dfa&scoped=true&"
import script from "./AccountControls.vue?vue&type=script&lang=js&"
export * from "./AccountControls.vue?vue&type=script&lang=js&"
import style0 from "./AccountControls.vue?vue&type=style&index=0&id=c2422dfa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2422dfa",
  null
  
)

export default component.exports